import { render, staticRenderFns } from "./EditorCitationsManagementTab.vue?vue&type=template&id=1c74cacd"
import script from "./EditorCitationsManagementTab.vue?vue&type=script&lang=ts"
export * from "./EditorCitationsManagementTab.vue?vue&type=script&lang=ts"
import style0 from "./EditorCitationsManagementTab.vue?vue&type=style&index=0&id=1c74cacd&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports